import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Tools from './Tools';
import socketIOClient from "socket.io-client";
import '../components/css/Monitor.css';
import { MonitorIcon, Filter, RefreshIcon } from '../components/icons/svgIcons';
import TimeAgo from 'javascript-time-ago';
import es from 'javascript-time-ago/locale/es.json';
import ReactTimeAgo from 'react-time-ago';
import { useHistory } from "react-router-dom";
import MoreMenu from './ui/moreMenu/MoreMenu';

const Monitor2 = (props) => {

    const [executives, setExecutives] = useState([]); 
    const [loading, setLoading] = useState(false);  
    const [error, setError] = useState(null);
    const [data, setData] = useState([]);
    const [filter, setFilter] = useState([]);
    const [filterExecutiveStatus, setFilterExecutiveStatus] = useState([]);
    const [countFilteredExecutives, setCountFilteredExecutives] = useState(0);
    const [companies, setCompanies] = useState([]);
    const [campaigns, setCampaigns] = useState([]);
    const [columnSort, setColumnSort] = useState(null);

    const defaultStatuses = ['ACTIVE', 'CALLING', 'RINGING', 'INGRESANDO GESTIÓN', 'ADM', 'ALM', 'BK', 'BN', 'CP', 'REU'];
    const allStatuses = ['ACTIVE', 'CALLING', 'RINGING', 'INGRESANDO GESTIÓN', 'LOGGED', 'LOGOUT', 'ADM', 'ALM', 'BK', 'BN', 'CP', 'REU'];
    const pauseStatuses = ['ADM', 'ALM', 'BK', 'BN', 'CP', 'REU'];

    let history = useHistory();

    const handleCheck = (event) => {
        if (event.target.checked) {
            setData({ ...data, [event.target.name]: true })
        } else {
            setData({ ...data, [event.target.name]: false })
        }
    }

    const handleChange = (event) => {
        setData({ ...data, [event.target.name]: event.target.value })
    }

    const getAllExecutivesSameCompanyGroup=()=>{
        setLoading(true);
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/exectivesSameCompanyGroup`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            params: {}
        };
        axios(options).then(response => {
            setExecutives(response.data.users);
        }).catch(function (error) {
            console.log("error:", error);
            setError(error.message);
            setLoading(false);
            if (error.response.status === 401) { Tools.logout(history); }
        });
    }

    const getAllCampaignsSameCompanyGroup=()=>{
        setLoading(true);
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/campaignsCompanyGroup`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            params: {}
        };
        axios(options).then(response => {
            setCampaigns(response.data);
        }).catch(function (error) {
            console.log("Error:", error.message);
            setError(error.message);
            setLoading(false);
            if (error.response.status === 401) { Tools.logout(history); }
        });
    }

    const getAllCompaniesSameCompanyGroup=()=>{
        setLoading(true);
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/companiesSameCompanyGroup`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',       
                'Authorization': currentSessionData.token
            },
            params: {}
        };
        axios(options).then(response => {
            setCompanies(response.data);
        }).catch(function (error) {
            console.log("Error:", error.message);
            setError(error.message);
            setLoading(false);
            if (error.response.status === 401) { Tools.logout(history); }
        });
    }

    const refreshFromDB = () => {
        getAllExecutivesSameCompanyGroup();
        getAllCampaignsSameCompanyGroup();
        getAllCompaniesSameCompanyGroup();
    }

    useEffect(() => {
        TimeAgo.addDefaultLocale(es);
        getAllExecutivesSameCompanyGroup();
        getAllCompaniesSameCompanyGroup();
        getAllCampaignsSameCompanyGroup();
        //setFilterExecutiveStatus(allStatuses);
        setFilterExecutiveStatus(defaultStatuses); //por defecto TODO, excepto desconectado y en sistema
    }, []);


    useEffect(() => {
        let sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        let extension = (sessionData ? sessionData.extension : 'NONE');
        const socket = Tools.connectClientToSocket(socketIOClient, extension, sessionData.name, sessionData.profile_code, sessionData.hostId, 'Monitor');

        //sockets monitor
        socket.on("monitor_executive_status", data => {

            // console.log('🐞DEBUG data.status.userId:', data.status.userId);
            console.log('🐞DEBUG data socket:', data.status);


            let currentExec = executives.find((exec) => exec._id === data.status.userId);
            if (currentExec) {
                console.log('Existe, actualizar');
                const currentExecutives = [...executives];
                currentExecutives.forEach((exec, index) => {
                    if (exec._id === data.status.userId) {
                        currentExecutives[index].currentStatus.eventCode = data.status.eventCode;
                        currentExecutives[index].currentStatus.eventDesc = data.status.eventDesc;
                        currentExecutives[index].currentStatus.startDate = data.status.startDate;
                        currentExecutives[index].campaignTasks = data.status.campaignTasks;
                        currentExecutives[index].inboundCallsDetail = data.status.inboundCallsDetail;

                        if(data.status.cmpDetails){

                            //actualiza info de CEDENTE del ejecutivo
                            currentExecutives[index].companyCampaignDetails={};
                            currentExecutives[index].companyCampaignDetails._id = data.status.cmpCnyDetails._id;
                            currentExecutives[index].companyCampaignDetails.name = data.status.cmpCnyDetails.name;

                            //actualiza info de CAMPAÑA del ejecutivo
                            currentExecutives[index].campaignDetails = data.status.cmpDetails;

                            //aprovecha de actualizar info de campaña
                            updateCampaignInfo(data.status.cmpDetails);
                        } else {
                            currentExecutives[index].companyCampaignDetails = null;
                            currentExecutives[index].campaignDetails = null;
                        }

                    }
                }, currentExecutives);
                setExecutives(currentExecutives);

            } else {
                console.log('No Existe, agregar');
            }


            //setCountFilteredExecutives(executives.length);

        });
    }, [executives]);


    const updateCampaignInfo=(cmpDetails)=>{
        console.log("COMPARA>>>>", cmpDetails, campaigns);
        let currentCampaigns = [...campaigns];
        const indexCampaign = currentCampaigns.findIndex((item) => item._id === cmpDetails._id);
        if (indexCampaign !== -1) {
            currentCampaigns[indexCampaign].progress = cmpDetails.progress;
            currentCampaigns[indexCampaign].ratioDialing = cmpDetails.ratioDialing;
            currentCampaigns[indexCampaign].abandonments = cmpDetails.abandonments;
        } 
        setCampaigns(currentCampaigns);
    }


    const addFilterExecStatus = (status) => {
        
        let filterES = [...filterExecutiveStatus];
        if (filterES.includes(status)) {
            const indexStatus=filterES.findIndex((item) => item === status);
            filterES.splice(indexStatus, 1);
        } else {
            filterES.push(status);
        }
        setFilterExecutiveStatus(filterES);
    }

    const addPauseToExecStatusFilter = () => {
        let filterES = [...filterExecutiveStatus];
        const containsAllPauseStatuses = pauseStatuses.every(status => filterES.includes(status));
        if (containsAllPauseStatuses) {
            filterES = filterES.filter(status => !pauseStatuses.includes(status));
        } else {
            pauseStatuses.forEach(status => {
                if (!filterES.includes(status)) {
                    filterES.push(status);
                }
            });
        }
        setFilterExecutiveStatus(filterES);
    };

    const addAllExecStatusFilter = () => {
        let filterES = [...filterExecutiveStatus];
        const containsAllPauseStatuses = allStatuses.every(status => filterES.includes(status));
        if (containsAllPauseStatuses) {
            filterES = filterES.filter(status => !allStatuses.includes(status));
        } else {
            allStatuses.forEach(status => {
                if (!filterES.includes(status)) {
                    filterES.push(status);
                }
            });
        }
        setFilterExecutiveStatus(filterES);
    };


    
    useEffect(() => {
        const filteredExecutives = executives.filter(executive => filterExecutiveStatus.includes(executive.currentStatus.eventCode));
        setCountFilteredExecutives(filteredExecutives.length);
    }, [filterExecutiveStatus]);

    const sortByColumn = (column) => {
        setColumnSort(column); //backup value
        const columnLevels = column.split('.');
        let currentExecutives = [...executives];
        const compare = (field) => (a, b) => {
            if (columnLevels.length ===1) {
                if (isNaN(a[field])) {
                    return a[field].toLowerCase().localeCompare(b[field].toLowerCase());
                } else {
                    return a[field] - b[field];
                }
            } else { //twoLevels
                if (a[columnLevels[0]] === undefined || b[columnLevels[0]] === undefined) {
                    return null;
                }

                if (isNaN(a[columnLevels[0]][columnLevels[1]])) {
                    return a[columnLevels[0]][columnLevels[1]].toLowerCase().localeCompare(b[columnLevels[0]][columnLevels[1]].toLowerCase());
                } else {
                    return a[columnLevels[0]][columnLevels[1]] - b[columnLevels[0]][columnLevels[1]];
                }
            }
        };
        setExecutives(currentExecutives.sort(compare(column)));
    }

    const supervisorLogout=()=>{
        Tools.logoutWM(history);
    }

    const disconnectAgent=(extension)=>{
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/remoteUserDisconnect`,
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            data: {
                extension: extension,
            }
        };

        axios(options).then(response => {
            if (response.status === 200) {
                console.log('user disconnect');
            }
        });
    }


    return (
        <div className="monitor monitorFont">  
            <h1 className='title'><MonitorIcon />CRM MONITOR</h1>
            <a className='sessionCloseButton' onClick={supervisorLogout}>Cerrar sesión</a>

            <div className="contentSectionWrapper flex">
                <div className="sidebarFilter">
                    <h3 className='titleMonitorSection'><Filter/>Filtros</h3>
                    <h5>ESTADO</h5>
                    <label><input checked={allStatuses.every(st => filterExecutiveStatus.includes(st))} name="filterItem1" type="checkbox" onChange={()=>addAllExecStatusFilter()} />Todos</label><br/>
                    <label><input checked={filterExecutiveStatus.includes('ACTIVE')} name="filterItem1" type="checkbox" onChange={()=>addFilterExecStatus('ACTIVE')} />Disponible</label><br/>
                    <label><input checked={filterExecutiveStatus.includes('CALLING')} name="filterItem1" type="checkbox" onChange={() => addFilterExecStatus('CALLING')} />En Llamada</label><br/>
                    <label><input checked={filterExecutiveStatus.includes('RINGING')} name="filterItem1" type="checkbox" onChange={() => addFilterExecStatus('RINGING')} />Ringing</label><br/>
                    <label><input checked={filterExecutiveStatus.includes('INGRESANDO GESTIÓN')} name="filterItem1" type="checkbox" onChange={() => addFilterExecStatus('INGRESANDO GESTIÓN')} />ING. GESTIÓN</label><br/>
                    <label><input checked={pauseStatuses.every(st => filterExecutiveStatus.includes(st))} name="filterItem1" type="checkbox" onChange={()=>addPauseToExecStatusFilter()} />En Pausa</label><br />
                    <label><input checked={filterExecutiveStatus.includes('LOGGED')} name="filterItem1" type="checkbox" onChange={() => addFilterExecStatus('LOGGED')} />En sistema</label><br />
                    <label><input checked={filterExecutiveStatus.includes('LOGOUT')} name="filterItem1" type="checkbox" onChange={() => addFilterExecStatus('LOGOUT')} />Desconectado</label>  
                </div>
                <div className="infoTable">
                    <h3 className='titleMonitorSection'>Campañas activas</h3>
                    <table className='gridTable'>
                        <thead>
                            <tr><th>CEDENTE</th><th>NOMBRE</th><th>TIPO</th><th>CREACIÓN</th><th>ITEMS</th><th>ABANDONOS</th><th>Avance</th><th>Ratio</th></tr>
                        </thead>
                        <tbody>
                            {campaigns.map((campaign, index) => {
                                return (
                                     executives.some(e => e.campaignDetails?._id === campaign._id) ? (
                                    <tr key={index}>
                                        <td>{campaign.companyInfo.name}</td>
                                        <td>{campaign.name}</td>
                                        <td>{campaign.type}</td>
                                        <td>{Tools.fdCL(campaign.date)}</td>
                                        <td className='right'>{Tools.fmtClNumber(campaign.itemCount)}</td>
                                        <td className='right'>{Tools.fmtClNumber(campaign.abandonments)}</td>
                                        <td className='right'>
                                            <div className="advanceMonitor"><div className="progressbar"><div className="ind grayscale" style={{ width: campaign.progress + "%" }}></div></div><div className="percentage">{campaign.progress}%</div></div>
                                        </td>
                                        <td className='right'>{Tools.fmtClNumber(campaign.ratioDialing)}</td>
                                    </tr>
                                    ) : null
                                    
                                )
                            })}  
                        </tbody>
                    </table>          

                    <hr className='blockSep'/>

                    <h3 className='titleMonitorSection'>Ejecutivos ({countFilteredExecutives} / {executives.length})</h3>

                    {/* <p className='debug'>executiveStatus: {JSON.stringify(filterExecutiveStatus)}</p>&nbsp;
                    <p className='debug'>companyFilter: {JSON.stringify(data.companyFilter)}</p>&nbsp;
                    <p className='debug'>campaignFilter (OUTBOUND): {JSON.stringify(data.campaignFilter)}</p>&nbsp;
                    <p className='debug'>INBOUND Filter: ALL</p>&nbsp;
                    <p className='debug'>DATE Filter: TODAY</p>
                    <br /> */}

                    <div className="flex rel">
                        <div className="wrapper">
                            <span className='boxTitle'>Cedente</span>
                            <select className="custom" name="companyFilter" defaultValue="" onChange={handleChange}>
                                <button>
                                    <selectedcontent></selectedcontent>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                        <path d="m6 9 6 6 6-6"></path>
                                    </svg>
                                </button>
                                <optgroup>
                                    <label>Cedente</label>
                                    <option value="" hidden disabled selected>Seleccione ...</option>
                                    <option value='ALL'>Todas</option>
                                    {companies.map(option =>
                                        <option key={option._id} value={option._id}>{option.name}</option>
                                    )}
                                </optgroup>
                            </select>
                        </div>

                        <div className="wrapper">
                            <span className='boxTitle'>Campaña</span>
                            <select className="custom" name="campaignFilter" defaultValue="" onChange={handleChange}>
                                <button>
                                    <selectedcontent></selectedcontent>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                        <path d="m6 9 6 6 6-6"></path>
                                    </svg>
                                </button>
                                <optgroup>
                                    <label>Campaña</label>
                                    <option value="" hidden disabled selected>Seleccione ...</option>
                                    <option value='ALL'>Todas</option>
                                    {campaigns.map(option =>
                                        <option key={option._id} value={option._id}>{option.name}</option>
                                    )}
                                </optgroup>
                            </select>
                        </div>

                        <button className='refreshMonitor' onClick={() => refreshFromDB()}><RefreshIcon width="20" height="20"/></button>
                    </div>

                    <table className='gridTable'>
                        <thead>
                            <tr>
                                <th></th>
                                <th><span onClick={() => sortByColumn('name')}>Ejecutivo</span></th>
                                <th><span onClick={() => sortByColumn('currentStatus.eventDesc')}>Estado</span></th>
                                <th><span onClick={() => sortByColumn('campaignDetails.name')}>CAMPAÑA</span></th>
                                <th><span onClick={() => sortByColumn('campaignTasks')}>#OUTBOUND</span></th> 
                                <th>INBOUND</th>
                            </tr>
                        </thead>
                        <tbody>
                            
                        {executives.map((executive, index) => {
                            return (
                                filterExecutiveStatus.includes(executive.currentStatus.eventCode) && 
                                (data.campaignFilter === undefined || data.campaignFilter === 'ALL' || data.campaignFilter === executive.campaignDetails?._id) &&
                                (data.companyFilter === undefined || data.companyFilter === 'ALL' || Number(data.companyFilter) === executive.companyCampaignDetails?._id)
                                 ? (
                                <tr key={index}>
                                    <td className='status'>
                                        <img className="profilePicture" src={executive.profilePicture} alt=""/>
                                        <i className={executive.currentStatus.eventCode === 'ACTIVE' ? 'status active' : executive.currentStatus.eventCode === 'LOGGED' ? 'status waiting' : executive.currentStatus.eventCode === 'RINGING' ? 'status calling' : 'status paused'} />
                                    </td>
                                    <td>{executive.name} ({executive.extension})</td>
                                    <td>
                                        <span className='xSmall'>{Tools.fdtCL(executive.currentStatus.startDate)}</span>
                                        {executive.currentStatus?.eventDesc} &nbsp;
                                        (Desde <ReactTimeAgo date={new Date(executive.currentStatus.startDate)} timeStyle="twitter" />)
                                    </td>

                                    {executive.companyCampaignDetails?(
                                        <td>
                                            <span className='xSmall'>{executive.companyCampaignDetails?.name} / {executive.campaignDetails?.type}</span>
                                            {executive.campaignDetails?.name}
                                        </td>
                                        ) : (
                                            <td><span className='filler'/></td>
                                        )
                                    }
                                    <td className='right'>
                                        {executive.companyCampaignDetails && executive.campaignTasks ? (
                                            <>
                                                <span className="summation">(Σ={executive.campaignTasks.reduce((acc, obj) => acc + obj.count, 0)})</span>
                                                <span>{Tools.fmtClNumber(executive.campaignTasks.reduce((acc, tsk) => acc + (tsk._id === Tools.getYMD(new Date()) ? tsk.count : 0), 0))}</span>
                                            </>
                                            ) 
                                            : 
                                            (<span className='filler' />
                                        )}
                                    </td>
                                    {/* <td>{executive.companyCampaignDetails ? (7) : (<span className='filler' />)}</td> */}
                                    
                                    
                                    <td>{executive.inboundCallsDetail? (
                                        <div>
                                        {executive.inboundCallsDetail.map((icd, idx) => {
                                            return (
                                                <span key={idx}>{icd.companyName}:{icd.count} {idx<executive.inboundCallsDetail.length-1 ? ', ' : ''}</span>
                                            )
                                        })}
                                        </div>
                                    ) : (<span className='filler' />)}</td>

                                    <td>
                                        <MoreMenu menuList={
                                            [{
                                                title: "Desconectar",
                                                action: () => { disconnectAgent(executive.extension) },
                                                visible: true
                                            }]} />
                                    </td>
                                </tr>
                                    ) : null
                            )
                        })}

                        </tbody>
                    </table>

                </div>
            </div>

        </div>
    );
    
}

export default Monitor2;
